import { FC} from "react";
import moment from "moment";
import { roundToTwoDecimalPlaces } from "../../../helper/helper";

export const TransactionReportTable: FC<{
  apiData: any;
  refetch?: any;
}> = ({ apiData, refetch }) => {
  return (
    <div className="w-full overflow-x-auto">
    <table
        className="w-full font-inter min-w-max"
        style={{ fontSize: "14px", cursor: "pointer" }}
    >
      <thead className={"m-6 bg-neutral-50 text-slate-900"}>
      <tr className="border-b rounded-lg">
          <th className="text-xs text-[#1A1B1D] font-medium py-3">Date</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Customer name</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Meter number</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Tariff</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Invoice number</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Cost of unit</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Units</th>
          <th className="text-xs text-[#1A1B1D] font-medium">Token generated</th>
        </tr>
      </thead>
      <tbody>
        {apiData.map((item: any, index: number) => {
          return (
            <tr className="border-b bg-white border-zinc-100" key={index}>
               <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
              {moment(item.transactionDate).format('DD/MM/YYYY h:mm a')}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.customerName}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.meterNumber}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.tariff}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.invoiceNumber}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.costOfUnit}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
              {roundToTwoDecimalPlaces(item.unit)}
              </th>
              <th className="text-xs text-[#1A1B1D] px-2 py-5 font-normal">
                {item.token}
              </th>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
  );
};
